<template>
    <span>{{formed_name}}</span>
</template>

<script>
import { JsItemName } from './jscomponents.js'; 

export default {
    name: "itemname",
    data() {
        return {
        formed_name:"",
        };
    },
    props: {
        ItemName:{
            type: String,
            required: true
         },
         ItemBrand:{
            type: String,
         },
         ItemStrength:{
            type: String,
         },
    },
    methods: {
        get_name(){
            var nm = JsItemName(this.ItemBrand, this.ItemStrength, this.ItemName);
            this.formed_name = nm;
            // const item_brand = this.ItemBrand != null ? this.ItemBrand : "";
            // const strength = this.ItemStrength != null ? this.ItemStrength : "";

            // const valid_name = item_brand != "" ? item_brand+" ("+this.ItemName+") "+strength : (strength!= "" ? this.ItemName+" ("+strength+")" : this.ItemName);
            // this.formed_name = valid_name;
        },
    },

    mounted() {
    this.get_name();
  },
};
</script>

<!-- <itemname ItemName="" ItemBrand="" ItemStrength="" /> -->